var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgFileFolderIcon = function SvgFileFolderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 28",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.833 28c-.834 0-1.792-.666-1.784-1.89l-.05-24.548C-.001.704.703 0 1.563 0h6.436l4 4h20v24H1.833z",
    fill: "currentColor"
  })));
};
export default SvgFileFolderIcon;